//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'

export default {
  components: {
    TopScreen,
    FooterTop
  },
  head () {
    return {
      title: this.$t('footer.products-services.cards').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
